<template>
  <div class="powerDetail-container">
    <div class="top">
      <el-row class="top">
        <el-button type="primary" @click="goBack">返回</el-button>
      </el-row>
      <el-row class="top">
        <el-row class="top-row">
          <el-col>站址名称</el-col>
          <el-col>站址编码</el-col>
          <el-col>所属省市区县</el-col>
          <el-col>发电工单数</el-col>
          <el-col>超过24小时发电工单数</el-col>
          <el-col>完成发电工单数</el-col>
          <el-col>总发电时长（小时）</el-col>
          <el-col>总发电量（kW·h）</el-col>
          <el-col>总发电油耗（L）</el-col>
          <el-col>最近一次发电</el-col>
          <el-col>经度</el-col>
          <el-col>纬度</el-col>
          <el-col>基本直流负载（A）</el-col>
          <el-col>详细地址</el-col>
          <!-- <el-col>维护部门</el-col> -->
        </el-row>
        <el-row class="bottom-row">
          <el-col>{{ $judgeEmpty(oneData.stationName) }}</el-col>
          <el-col>{{ $judgeEmpty(oneData.stationCode) }}</el-col>
          <el-col
            >{{ $judgeEmpty(oneData.province) }}，{{
              $judgeEmpty(oneData.city)
            }}，{{ $judgeEmpty(oneData.area) }}</el-col
          >
          <el-col>{{ $judgeEmpty(oneData.dynamoCount) }}</el-col>
          <el-col>{{ $judgeEmpty(oneData.exceedDynamoCount) }}</el-col>
          <el-col>{{ $judgeEmpty(oneData.dynamoSuccessCount) }}</el-col>
          <el-col>{{ $judgeEmpty(oneData.dynamoTime) }}</el-col>
          <el-col>{{ $judgeEmpty(oneData.dynamoEnergy) }}</el-col>
          <el-col>{{ $judgeEmpty(oneData.dynamoOil) }}</el-col>
          <el-col>{{ $judgeEmpty(oneData.lastDynamoDate) }}</el-col>
          <el-col>{{ $judgeEmpty(oneData.longitude) }}</el-col>
          <el-col>{{ $judgeEmpty(oneData.latitude) }}</el-col>
          <el-col>{{ $judgeEmpty(oneData.dcLoadCurrent) }}</el-col>
          <el-col>{{ $judgeEmpty(oneData.address) }}</el-col>
          <!-- <el-col>{{ $judgeEmpty(oneData.dept) }}</el-col> -->
        </el-row>
      </el-row>
      <el-row class="top">
        <el-row class="top-row">
          <el-col>工单编号</el-col>
          <el-col>派单时间</el-col>
          <el-col>回单时间</el-col>
          <el-col>发电记录数</el-col>
          <el-col>是否超过24小时</el-col>
          <el-col>发电量（kW·h）</el-col>
          <el-col>发电油耗（L）</el-col>
          <el-col>回单结果</el-col>
          <el-col>未完成原因</el-col>
          <el-col>工单类型</el-col>
          <el-col>工单状态</el-col>
          <el-col>工单内容</el-col>
          <el-col>派单人员</el-col>
          <el-col>审核状态</el-col>
        </el-row>
        <el-row class="bottom-row">
          <el-col>{{ $judgeEmpty(twoData.subjectNum) }}</el-col>
          <el-col>{{ $judgeEmpty(twoData.dispatchTime) }}</el-col>
          <el-col>{{ $judgeEmpty(twoData.receiptTime) }}</el-col>
          <el-col>{{ $judgeEmpty(twoData.dynamoCount) }}</el-col>
          <el-col>{{ twoData.exceedDay ? "是" : "否" }}</el-col>
          <el-col>{{ $judgeEmpty(twoData.dynamoEnergy) }}</el-col>
          <el-col>{{ $judgeEmpty(twoData.dynamoOil) }}</el-col>
          <el-col>
            <span v-if="twoData.receiptState == 1">未完成发电</span>
            <span v-else-if="twoData.receiptState == 2">完成发电</span>
            <span v-else>-</span>
          </el-col>
          <el-col>{{ $judgeEmpty(twoData.receiptMessage) }}</el-col>
          <el-col>
            <span v-if="twoData.type == 1">计划发电</span>
            <span v-else-if="twoData.type == 2">应急发电</span>
            <span v-else>-</span>
          </el-col>
          <el-col>
            <span v-if="twoData.receiveState == 1">待接单</span>
            <span v-else-if="twoData.receiveState == 2">已接单</span>
            <span v-else-if="twoData.receiveState == 3">已回单</span>
            <span v-else>-</span>
          </el-col>
          <el-col>{{ $judgeEmpty(twoData.errorContent) }}</el-col>
          <el-col>{{ $judgeEmpty(twoData.dispatchMan) }}</el-col>
          <el-col>
            <span v-if="twoData.orderReview == 1">待审核</span>
            <span v-else-if="twoData.orderReview == 2">审核拒绝</span>
            <span v-else-if="twoData.orderReview == 3">审核通过</span>
            <span v-else>-</span>
          </el-col>
        </el-row>
      </el-row>
    </div>
    <div class="bottom">
      <el-button type="primary" @click.stop="exportButton">导出</el-button>
      <div style="height:20px"></div>
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        size="mini"
        stripe
        height="560px"
      >
        <el-table-column width="40"></el-table-column>
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column
          label="发电车辆"
          prop="plateNum"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="使用人" prop="ownerName" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span v-if="row.ownerName != ''">{{ row.ownerName }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="dept"
          label="归属部门"
          min-width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="发电开始时间"
          prop="startTime"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="发点结束时间"
          prop="endTime"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="发电时长（小时）"
          prop="duration"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="发电量（kW·h）"
          prop="capacity"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="发电油耗（L）"
          prop="oil"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="操作" min-width="80">
          <template slot-scope="{ row }">
            <el-button type="text" @click.stop="checkDetail(row)"
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="limit"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "PowerDetail",
  data() {
    return {
      oneData: {},
      twoData: {},
      tableData: [],
      total: 0,
      currentPage: 1,
      limit: 10,
    };
  },
  beforeRouteLeave(to, from, next) {
    if (to.path == "/PowerRecordDetail") {
      let path = from.path;
      sessionStorage.setItem("pathUrl", path);
    }
    next();
  },
  created() {
    let currentPage = this.$route.params.currentPage;
    if (currentPage) {
      this.currentPage = parseInt(currentPage);
    }
    console.log(currentPage);
    let vehicleInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    let workOrderInfo = JSON.parse(sessionStorage.getItem("workOrderInfo"));
    let oneData = vehicleInfo;
    let twoData = this.$route.params.data || workOrderInfo;
    this.oneData = oneData;
    this.twoData = twoData;
    this.getOneData();
    this.getTableData();
  },
  methods: {
    goBack() {
      this.$router.push({
        name: "PowerRecordMore",
        params: {
          currentPage: sessionStorage.getItem("powerRecordCurrentPage"),
        },
      });
    },
    checkDetail(data) {
      this.$router.push({
        name: "PowerRecordDetail",
        params: {
          vin: data.vin,
          id: data.id,
          subjectNum: data.subjectNum,
        },
      });
      sessionStorage.setItem("powerDetailCurrPage", this.currentPage);
      sessionStorage.setItem("statisticsSubjectNum", this.twoData.subjectNum);
    },
    exportButton() {
      let _this = this;
      let url = "";
      url =
        "/api/base/station/Statistics/counts/export?subjectNum=" +
        _this.twoData.subjectNum;
      window.location.href = url;
    },
    async getOneData() {},
    async getTableData() {
      let obj = {};
      obj.subjectNum = this.twoData.subjectNum;
      obj.limit = this.limit;
      obj.page = this.currentPage;
      let { data: res } = await this.$axios.get(
        "/api/base/station/Statistics/dynamo/counts",
        {
          params: obj,
        }
      );
      if (res.code == 1) {
        this.tableData = res.data.list;
        this.total = res.data.totalCount;
      }
    },
    //pagesize改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    //页数改变时触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getTableData();
    },
  },
};
</script>

<style lang="scss" scoped>
.powerDetail-container {
  margin: 20px;
  height: calc(100% - 40px);
  .top {
    width: 100%;
    overflow-x: auto;
    .top-row {
      display: flex;
      margin-top: 20px !important;

      .el-col {
        background: #f4f4f4;
      }
    }
    .bottom-row {
      display: flex;
      .el-col {
        border-top: none;
        background: #fff;
      }
    }
    .el-col {
      line-height: 38px;
      min-width: 200px;
      padding: 0 5px !important;
      text-align: center;
      border: 1px solid #ccc;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .el-col + .el-col {
      border-left: none;
    }
  }
  .bottom {
    height: calc(100% - 60px - 247px);
    margin-top: 20px;
    padding: 20px;
    background: #fff;
  }
}
</style>
